import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function ReviewModal({ open, setOpen, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="review-modal">
      <div
        style={{
          padding: "0px 40px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            width: { xs: "90%", sm: 500 },
            p: 4,
            textAlign: "center",
            backgroundColor: "#1a222a",
            border: "1px solid #1a222a",
            position: "relative",
          }}
        >
          {/* Top Right Close (optional) */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 10, right: 10 }}
          >
            <CloseIcon sx={{ color: "#fff" }} />
          </IconButton>

          {/* Title */}
          <Typography
            gutterBottom
            sx={{
              color: "#fff",
              fontSize: "24px",
              fontFamily: "Questrial",
            }}
          >
            Submission Under Review
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {/* Image in Center */}
          <Box
            component="img"
            src={"./images/timer.png"}
            alt="submission preview"
            sx={{
              width: "100%",
              maxWidth: 250,
              height: "150px",
              borderRadius: 2,
              mt: 2,
              mb: 2,
              mx: "auto",
              objectFit: "contain",
            }}
          />

          <Typography
            color="text.secondary"
            gutterBottom
            sx={{
              color: "#fff",
              fontSize: "16px",
              fontFamily: "Questrial",
            }}
          >
            This submission is currently under review by Our team. The Status
            will be Updated in 2 to 12 hours
          </Typography>

          {/* Bottom Close Button */}
          <Button
            color="primary"
            onClick={handleClose}
            sx={{
              mt: 3,
              color: "#fff",
              textTransform: "inherit",
              backgroundColor: "rgb(96, 64, 238)",
              "&:hover": {
                backgroundColor: "rgb(96, 64, 238)", // same as normal
              },
            }}
            fullWidth
          >
            Close
          </Button>
        </Box>
      </div>
    </Modal>
  );
}

export default ReviewModal;
